import { ChangeDetectionStrategy, Component } from '@angular/core';
import {
  MARKETING_WHY_CHOOSE_FEATURES,
  MARKETING_WHY_CHOOSE_HEADING,
  type MarketingWhyChooseFeature,
} from './marketing-why-choose.data';

@Component({
  selector: 'app-marketing-why-choose',
  standalone: true,
  changeDetection: ChangeDetectionStrategy.OnPush,
  template: `
    <section class="h1-section h1-section--dark" id="why">
      <div class="h1-section__inner">
        <header class="h1-section__head">
          <h2>{{ heading.title }}</h2>
          <p>{{ heading.subtitle }}</p>
        </header>

        <div class="h1-why-grid">
          @for (feature of features; track feature.title) {
            <article
              class="h1-why-card"
              [class.h1-why-card--featured]="feature.tone === 'featured'"
              [class.h1-why-card--accent]="feature.tone === 'accent'"
            >
              <div class="h1-why-card__icon" aria-hidden="true">
                <svg
                  viewBox="0 0 24 24"
                  fill="none"
                  stroke="currentColor"
                  stroke-width="1.75"
                  stroke-linecap="round"
                  stroke-linejoin="round"
                  focusable="false"
                >
                  @switch (feature.icon) {
                    @case ('brain-cog') {
                      <path d="M12 5a3 3 0 1 0-5.997.142 4 4 0 0 0-2.526 5.77 4 4 0 0 0 .556 6.588A4 4 0 1 0 12 18Z"></path>
                      <path d="M9 13a4.5 4.5 0 0 0 3-4"></path>
                      <path d="M6.003 5.125A3 3 0 0 0 6.401 6.5"></path>
                      <path d="M3.477 10.896a4 4 0 0 1 .585-.396"></path>
                      <path d="M6 18a4 4 0 0 1-1.967-.516"></path>
                      <path d="m15.7 19.4 1.6 1.6"></path>
                      <path d="m17.3 17 1.6-1.6"></path>
                      <path d="m19.7 19.4 1.6-1.6"></path>
                      <path d="m17.3 21.8-1.6-1.6"></path>
                      <circle cx="18.5" cy="19.5" r="2.5"></circle>
                    }
                    @case ('shield-check') {
                      <path
                        d="M20 13c0 5-3.5 7.5-7.66 8.95a1 1 0 0 1-.67-.01C7.5 20.5 4 18 4 13V6a1 1 0 0 1 1-1c2 0 4.5-1.2 6.24-2.72a1.17 1.17 0 0 1 1.52 0C14.51 3.81 17 5 19 5a1 1 0 0 1 1 1z"
                      ></path>
                      <path d="m9 12 2 2 4-4"></path>
                    }
                    @case ('landmark') {
                      <line x1="3" x2="21" y1="22" y2="22"></line>
                      <line x1="6" x2="6" y1="18" y2="11"></line>
                      <line x1="10" x2="10" y1="18" y2="11"></line>
                      <line x1="14" x2="14" y1="18" y2="11"></line>
                      <line x1="18" x2="18" y1="18" y2="11"></line>
                      <polygon points="12 2 20 7 4 7"></polygon>
                    }
                    @case ('plane-takeoff') {
                      <path d="M2 22h20"></path>
                      <path
                        d="M6.36 17.4 4 17l-2-4 1.1-.55a2 2 0 0 1 1.8 0l.17.1a2 2 0 0 0 1.8 0L8 12 5 6l.9-.45a2 2 0 0 1 2.09.2l4.02 3a2 2 0 0 0 2.1.2l4.19-2.06a2.41 2.41 0 0 1 1.73-.17L21 7a1.4 1.4 0 0 1 .87 1.99l-.38.76c-.23.46-.6.84-1.07 1.08L7.58 17.2a2 2 0 0 1-1.22.18Z"
                      ></path>
                    }
                    @case ('globe') {
                      <circle cx="12" cy="12" r="10"></circle>
                      <path d="M12 2a14.5 14.5 0 0 0 0 20 14.5 14.5 0 0 0 0-20"></path>
                      <path d="M2 12h20"></path>
                    }
                  }
                </svg>
              </div>
              <h3>{{ feature.title }}</h3>
              <p>{{ feature.description }}</p>
              @if (feature.link) {
                <a [href]="feature.link.href" class="h1-why-card__link">
                  {{ feature.link.label }}
                  <span aria-hidden="true">→</span>
                </a>
              }
            </article>
          }
        </div>
      </div>
    </section>
  `,
})
export class MarketingWhyChooseComponent {
  readonly heading = MARKETING_WHY_CHOOSE_HEADING;
  readonly features: MarketingWhyChooseFeature[] = MARKETING_WHY_CHOOSE_FEATURES;
}
